/**
 * Format Utils
 *
 * @since 2018-03-29
 * @author kdydesign.kim
 */

const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

// format
export function humanStorageSize (bytes) {
  let u = 0

  while (parseInt(bytes, 10) >= 1024 && u < units.length - 1) {
    bytes /= 1024
    ++u
  }

  return `${bytes.toFixed(1)} ${units[u]}`
}

// 파이프를 기준으로 분리
// '1111|2222' => ['1111', '2222']
export function splitPipe (value) {
  return replaceBrackets(value).split('|')
}

// 대괄호 제거
// '[1|2|3]' => '1|2|3'
export function replaceBrackets (value) {
  return value.replace('[', '').replace(']', '')
}

// 비트 데이터 포맷 변경
// 000010 => 1
// 요일의 경우 0100010 => 월, 금
export function bitToFormat (data, suffix = '') {
  const arr = _.toArray(data)
  const used = _.map(arr, (d, i) => {
    if (Number(d) === 1) {
      return `${i + 1}`
    }
  })

  const sortData = _.sortBy(_.compact(used), (d) => {
    return Number(d)
  })

  return _.join(_.map(sortData, (o) => {
    return `${o}${suffix}`
  }), ', ')
}

// 비트 데이터 -> Array
export function bitToArray (data) {
  const arr = _.toArray(data)
  const used = _.map(arr, (d, i) => {
    if (Number(d) === 1) {
      return Number(`${i + 1}`)
    }
  })

  const sortData = _.sortBy(_.compact(used), (d) => {
    return Number(d)
  })

  return sortData
}

// 숫자에 3자리 단위로 콤마 추가하여 문자열 리턴
export function addCommaNum (num) {
  const regexp = /\B(?=(\d{3})+(?!\d))/g
  return num.toString().replace(regexp, ',')
}

// BigInt인 경우 value 정보 Return
export function getBigIntValue (val) {
  if (val === undefined || _.isNull(val)) {
    return ''
  }
  if (val.valueOf === undefined) {
    return val
  }
  return val.valueOf()
}

// 문자열을 바이너리로 변경하여 리턴한다. PcapViewer에서 사용한다.
export function stringToHex (hex) {
  let bytes = ''

  for (let c = 0, max = hex.length; c < max; c += 2) {
    bytes += `${hex.substr(c, 2)} `
  }

  bytes = bytes.slice(0, bytes.length - 1)

  return bytes
}
